<template>
	<div class="top">
		<div class="bg-white padding-tb-sm">
			<div class="flex align-center justify-between topone">
				<p class="text-xs text-666">工友您好，铯镨旗下蓝友招工平台欢迎您</p>

				<el-tooltip class="item" placement="bottom" effect="light">
				      <div class="flex align-center pointer">
				      	<img class="topwechat" src="../../assets/img/topwechat.png" >
				      	<p class="text-xs text-666">关注微信</p>
				      </div>
					   <div slot="content">
						   <img class="block-143" :src="work_ewm" >
					   </div>
				</el-tooltip>
			</div>
		</div>
		<div class="padding-tb-sm">
			<div class="topone flex align-center justify-between">
				<div class="flex align-center" @click="gocity()">
					<img class="logo margin-right" src="../../assets/logo.png" >
					<div class="flex align-center">
						<img class="address" src="../../assets/img/address.png" >
						<p class="city pointer">{{city}}</p>
						<i class="el-icon-arrow-down"></i>
					</div>
				</div>
				<div class="flex entry justify-between padding-left-sm">
					<input type="" v-model="seachinfo" name="" id="" value="" placeholder="请输入关键词..." style="background-color: #FFF;"/>
					<img class="seach-btn pointer" @click="goseach()" src="../../assets/img/seach-btn.png" >
          <img src="" alt="">
				</div>
			</div>
		</div>
		<div class="bg-theme">
			<div class="topone flex justify-between align-center height67">
				<div class="flex align-center">
					<p class="top-item height67 text-white pointer" :class="chosename == item.path?'active':''" v-for="(item,index) in toplist" :key="index" @click="golink(item)">{{item.name}}</p>
				</div>
				<div class="login-btn pointer" v-if="!userInfo" @click="gologin">登录 / 注册</div>
				<div class="login-btn pointer" v-if="userInfo" @click="outlogin">退出登录</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js';
  import {mapState} from 'vuex';
	export default {
		// props:{
		// 	chosename: {
		// 	  type: String,
		// 	  default:'home'
		// 	},
		// },
		data () {
			return {
				seachinfo:'',//搜素内容
				toplist:[
					{
						name:'首页',
						path:'home'
					},{
						name:'找工作',
						path:'worker'
					},{
						name:'工人简历',
						path:'resume'
					},{
						name:'技能培训',
						path:'skill'
					},{
						name:'二手租赁',
						path:'lease'
					},{
						name:'招标信息',
						path:'bidding'
					},
					{
						name:'供应链',
						path:'supplyList'
					},{
						name:'个人中心',
						path:'center'
					},
				],//顶部主页面
				chosename:'',//当前所在主页面
				type:1,//1找活，2招工，3课程，4二手，5招标，6供应链
				work_ewm:''
				// islogin:false,//是否登录
				// userInfo:localStorage.getItem('USER_INFO')||''
			}
		},
		computed: {
			userInfo() {
				if (this.$store.getters.userInfo) {
					return this.$store.getters.userInfo;
				} else {
					return JSON.parse(localStorage.getItem('USER_INFO'));
				}
			},
			city(){
				return this.$store.getters.city;
			},
      ...mapState(['isFirm'])
		},
		created(){
			//显示选中的是哪个
			Bus.$on('chosename',data=>{
				console.log(data,'显示选中的是哪个')
				this.chosename = data
				this.type = this.fitype(data)
				this.seachinfo = ''
			})
			let token = localStorage.getItem('user_token');
			this.getwordsewm()
		},
		// destroyed() {
		// 	Bus.$off()
		// },
		// beforeUpdate(){

		// 	let path = this.$route.path
		// 	console.log(path);
		// 	if(path == '/'){
		// 		this.chosename = 'home'
		// 	}else{
		// 		let pathlen = this.$route.path.length
		// 		this.chosename = path.substring(1, pathlen)
		// 	}
		// },
		methods:{
			fitype(type){
				switch (type) {
				  case 'home':
				    return 1;
				  case 'worker':
				    return 1;
				  case 'resume':
				    return 2;
				  case 'skill':
				    return 3;
				  case 'lease':
				    return 4;
				  case 'bidding':
				    return 5;
				  case 'center':
				    return 2;
          case 'supplyList':
            return 6;
				  default:
				    return '';
				}
			},
			/**
			 * 显示登录弹窗
			 * */
			gologin(){
				console.log('------------');
				Bus.$emit('showlogon')
			},
			getwordsewm(){
				this.ajax('get', '/api/pc/system/getwordsewm', {}, res => {
					if(res.status == 200){
						this.work_ewm = res.data.header_ewm
					}
				})
			},
			//退出登录
			outlogin(){
				// localStorage.removeItem('user_token')
				// localStorage.removeItem('USER_INFO')
				this.$store.commit('logout')
				console.log('outlogin',this.chosename);
				if(this.chosename == 'center'){
					this.$router.push({
						name:'home',
						query: {

						}
					})
				}

			},
			//跳转主页面
			golink(item){
				//如果当前在这个页面
				if(this.chosename == item.path) return
				// 点击了个人中心,判断是否登录
				if(item.path == 'center'){
					if(localStorage.getItem('user_token')){
						this.chosename = item.path
						this.$forceUpdate()
						this.$router.push({
							name:item.path,
							query: {

							}
						})
					}else{
						Bus.$emit("showlogon")
					}
					// 点击了供应链同理判断是否登录
				}else if(item.path == 'supplyList'){
					if(!localStorage.getItem('user_token')){
						Bus.$emit("showlogon")
						return false;
					}

          // 如果登录了就判断是否企业认证，使用vuex存储
          this.ajax('get', '/api/pc/userReal/getCompany', {}, res => {
            if (res.data.code==202) {
              this.$message.error('当前没有企业认证，请先进行企业认证');
                this.$router.push({
                	name:'center',
                	query: {
                		type:'enterprise'
                	}
                })

                this.chosename = 'center';

            }else{
              // 1/登录 2/企业认证完成就进入供应链
              	this.chosename = item.path
              	this.$forceUpdate();
              	this.$router.push({
              		name:item.path,
              		query: {}
              	})
            }
          })



				}else{
					this.chosename = item.path
					this.$forceUpdate()
					this.$router.push({
						name:item.path,
						query: {

						}
					})
				}

			},
			//选中城市
			gocity(){
				this.$router.push({
					name:'city',
					query: {

					}
				})
			},
			//搜索
			goseach(){
				if (!this.seachinfo) return alert('请输入关键词')
				this.$router.push({
					name:'seach',
					query: {
						seachinfo:this.seachinfo,
						type:this.type,
						city:this.city
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.top{
		// position: absolute;
		background: #F6F6F8;
		// top: 0;
		// left: 0;
		// right: 0;
		.topone{
			width: 1210px;
			margin: 0 auto;
		}
		.topwechat{
			width: 20px;
			height: 18px;
		}
		.logo{
			width: 62px;
			height: 62px;
		}
		.address{
			width: 17px;
			height: 20px;
		}
		.city{
			margin: 0 19px 0 5px;
		}
		.seach-btn{
			width: 48px;
			height: 42px;
		}
		.entry{
			width: 367px;
			height: 43px;
			background: #FFFFFF;
			box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
			border-radius: 22px;
			input{
				width: 300px;
				border: 0;
				border-radius: 22px;
				 outline: 0;
			}
		}
		.bg-theme{
			background: #09827B;
		}
		.top-item{
			width: 113px;
		}
		.top-item:hover{
			background: #07706A;
		}
		.active{
			background: #07706A;
		}
		.login-btn{
			width: 108px;
			height: 42px;
			line-height: 42px;
			color: #E6E6E6;
			border: 1px solid #E6E6E6;
			border-radius: 21px;
		}
		.height67{
			height: 67px;
			line-height: 67px;
		}
	}
	.block-143{
		width: 143px;
		height: 143px;
	}
</style>



// WEBPACK FOOTER //
// src/components/public/top.vue